<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box op_down modal_cont" id="maintenance">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_game_maintenance_title }}</h1>
        <img src="static/images/profile/profile-emptystate.png" class="op_down_img">
        <p>{{ getTranslations.home_modals_game_maintenance_description_1 }}<br>
          {{ getTranslations.home_modals_game_maintenance_description_2 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'game-maintenance',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Maintenance.vue